// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';

import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export default function ConfirmationModal({ title, show, setShow, onConfirm, content }) {
    const { i18n, t } = useTranslation();
    
    return (
        <Modal 
            className="default-modal"
            show={show}
            backdrop = "static"
            onHide={() => setShow(false)}
            contentClassName="delete-modal"
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            {content && <Modal.Body>{content}</Modal.Body>}
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    {t("modal_cancel")}
                </Button>
                <Button variant="primary" onClick={() => {setShow(false); onConfirm();}}>
                    {t("modal_delete")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
